<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 25C12.9294 25 13.716 24.3576 13.9376 23.4948C14.0064 23.2274 13.7761 23 13.5 23H10.5C10.2239 23 9.99363 23.2274 10.0624 23.4948C10.284 24.3576 11.0706 25 12 25Z" fill="#152E39"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 11.5V19L20.8536 20.8535C20.9473 20.9473 21 21.0745 21 21.2071V21.5C21 21.7761 20.7761 22 20.5 22H3.5C3.22386 22 3 21.7761 3 21.5V21.2071C3 21.0745 3.05268 20.9473 3.14645 20.8535L5 19V11.5C5 8.42 7.64 5.86 10.5 5.18V4.5C10.5 3.67 11.17 3 12 3C12.83 3 13.5 3.67 13.5 4.5V5.18C16.37 5.86 19 8.43 19 11.5ZM12 7C9.23858 7 7 9.23858 7 12V19.5C7 19.7761 7.22386 20 7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V12C17 9.23858 14.7614 7 12 7Z" fill="#152E39"/>
    <circle v-if="isHasNotification" cx="23" cy="3" r="3" fill="#F14358"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      default: 186,
      type: Number,
    },
    heigth: {
      default: 148,
      type: Number,
    },
    isHasNotification: {
      default: false,
      type: Boolean,
    }
  },
}
</script>
